// 秘密値のマスク（GYM-288）の共通ロジック
//
// サーバは秘密項目（決済の秘密鍵・APIキー・スマートロックの認証情報・LINE のチャネルシークレット等）を
// 「先頭5文字 + ***」にマスクして返す（server/app/models/concerns/secret_maskable.rb）。
// マスク値をそのまま保存すると実値が壊れるため、サーバ側にも
// 「末尾が *** なら無視」というガードがあるが、フロント側でも送らない（多層防御）。

export const MASK_SUFFIX = '***'

// 店舗設定（/cmp/account/company）でマスクして返ってくるトップレベルの秘密項目。
// サーバの MASKED_ATTRS（server/app/controllers/api/cmp/account/company_controller.rb）と一致させること。
// smartlock_settings 内の秘密値はサーバがキー単位で既存値に戻すため、ここでは扱わない。
export const COMPANY_MASKED_ATTRS = [
  'pay_service_sk',
  'onesignal_sk',
  'chatwork_api_key'
]

/**
 * マスク済みの秘密値かどうか。
 *
 * 判定はサーバ（SecretMaskable.masked_secret?）と同じく「末尾が *** 」の緩い条件にする。
 * ちょうど8文字（/^.{5}\*\*\*$/）で判定すると、利用者がマスク値を
 * 部分編集した場合（例: 'abc***' のように途中を削った場合）にすり抜けてしまう。
 *
 * @param {*} value 判定対象
 * @returns {boolean} マスク値なら true
 */
export const isMaskedSecret = function (value) {
  if (typeof value !== 'string') return false
  return value.endsWith(MASK_SUFFIX)
}

/**
 * 保存ペイロードからマスク値のままのキーを取り除く（元オブジェクトは変更しない）。
 *
 * @param {Object} payload 保存対象のオブジェクト
 * @param {Array<String>} attrs 秘密項目のキー
 * @returns {Object} マスク値のキーを削除した新しいオブジェクト
 */
export const stripMaskedAttrs = function (payload, attrs) {
  if (!payload || typeof payload !== 'object') return payload
  const result = { ...payload }
  attrs.forEach(attr => {
    if (isMaskedSecret(result[attr])) delete result[attr]
  })
  return result
}
